import React, { useContext } from 'react';

import { SidePanelContext } from './SidePanel';

interface IProps {
  children: React.ReactNode;
  subTitle?: string | React.ReactNode;
  displayCloseButton?: boolean;
}

function SidePanelHeader({ children, subTitle, displayCloseButton }: IProps) {
  const slideInPanelContext = useContext(SidePanelContext);
  const { closeHandler } = slideInPanelContext;

  return (
    <header className="novoSidePanel__header">
      {displayCloseButton && closeHandler && (
        <button className="novoSidePanel__header__close material-icons" onClick={closeHandler}>
          close
        </button>
      )}

      <h2 className="novoSidePanel__header__title">{children}</h2>
      {subTitle && <h3 className="novoSidePanel__header__sub-title">{subTitle}</h3>}
    </header>
  );
}

export default SidePanelHeader;
